<div class="login-container">
  <div class="background">
    <div class="gradient-overlay"></div>
    <div class="particles">
      <div class="particle particle-1"></div>
      <div class="particle particle-2"></div>
      <div class="particle particle-3"></div>
      <div class="particle particle-4"></div>
      <div class="particle particle-5"></div>
    </div>
  </div>

  <div class="login-panel" [class.success-mode]="resetSuccess">
    <div class="login-panel-left">
      <div class="brand-logo">
        <svg viewBox="0 0 24 24" class="logo-icon">
          <path
            d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"
          ></path>
        </svg>
        <span class="logo-text">Markado</span>
      </div>

      <div class="illustration">
        <div class="illustration-circle"></div>
        <div class="illustration-shape shape-1"></div>
        <div class="illustration-shape shape-2"></div>
        <div class="illustration-shape shape-3"></div>
      </div>

      <div class="welcome-text">
        <h1 *ngIf="!resetSuccess">Reset Password</h1>
        <h1 *ngIf="resetSuccess">Success!</h1>
        <p *ngIf="!resetSuccess">
          Create a new secure password for your account
        </p>
        <p *ngIf="resetSuccess">Your password has been updated successfully</p>
      </div>
    </div>

    <div class="login-panel-right" *ngIf="!resetSuccess">
      <div class="login-header">
        <h2>Create New Password</h2>
        <p>Your password must be different from previously used passwords</p>
      </div>

      <form
        [formGroup]="resetPasswordForm"
        (ngSubmit)="onSubmit()"
        class="reset-password-form login-form"
      >
        <div class="alert alert-error" *ngIf="tokenInvalid">
          <svg class="alert-icon" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
          <span>{{ errorMessage }}</span>
        </div>

        <div
          class="form-group"
          [class.form-error]="
            password?.invalid && (password?.dirty || password?.touched)
          "
          *ngIf="!tokenInvalid"
        >
          <label for="password">New Password</label>
          <div class="input-wrapper">
            <svg class="input-icon" viewBox="0 0 24 24">
              <path
                d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
              ></path>
            </svg>
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="password"
              formControlName="password"
              placeholder="••••••••"
              [class.is-invalid]="
                password?.invalid && (password?.dirty || password?.touched)
              "
            />
            <button
              type="button"
              class="toggle-password"
              (click)="togglePasswordVisibility()"
              tabindex="-1"
            >
              <svg class="eye-icon" viewBox="0 0 24 24" *ngIf="!showPassword">
                <path
                  d="M12 6c-5.33 0-9.67 4-9.67 4s4.33 4 9.67 4 9.67-4 9.67-4-4.33-4-9.67-4zm0 6.67c-1.47 0-2.67-1.2-2.67-2.67S10.53 7.33 12 7.33s2.67 1.2 2.67 2.67-1.2 2.67-2.67 2.67z"
                ></path>
                <circle cx="12" cy="10" r="2"></circle>
              </svg>
              <svg class="eye-icon" viewBox="0 0 24 24" *ngIf="showPassword">
                <path
                  d="M12 6c-5.33 0-9.67 4-9.67 4s4.33 4 9.67 4 9.67-4 9.67-4-4.33-4-9.67-4zm0 6.67c-1.47 0-2.67-1.2-2.67-2.67S10.53 7.33 12 7.33s2.67 1.2 2.67 2.67-1.2 2.67-2.67 2.67z"
                ></path>
                <line
                  x1="4"
                  y1="4"
                  x2="20"
                  y2="20"
                  stroke="currentColor"
                  stroke-width="2"
                ></line>
              </svg>
            </button>
          </div>
          <div
            class="error-text"
            *ngIf="password?.invalid && (password?.dirty || password?.touched)"
          >
            <div *ngIf="password?.errors?.['required']">
              Password is required
            </div>
            <div *ngIf="password?.errors?.['minlength']">
              Password must be at least 8 characters
            </div>
            <div *ngIf="password?.errors?.['passwordPattern']">
              Password must include an uppercase letter, a number, and a special
              character
            </div>
          </div>
        </div>

        <div
          class="form-group"
          [class.form-error]="
            confirmPassword?.invalid &&
            (confirmPassword?.dirty || confirmPassword?.touched)
          "
          *ngIf="!tokenInvalid"
        >
          <label for="confirmPassword">Confirm Password</label>
          <div class="input-wrapper">
            <svg class="input-icon" viewBox="0 0 24 24">
              <path
                d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
              ></path>
            </svg>
            <input
              [type]="showConfirmPassword ? 'text' : 'password'"
              id="confirmPassword"
              formControlName="confirmPassword"
              placeholder="••••••••"
              [class.is-invalid]="
                confirmPassword?.invalid &&
                (confirmPassword?.dirty || confirmPassword?.touched)
              "
            />
            <button
              type="button"
              class="toggle-password"
              (click)="toggleConfirmPasswordVisibility()"
              tabindex="-1"
            >
              <svg
                class="eye-icon"
                viewBox="0 0 24 24"
                *ngIf="!showConfirmPassword"
              >
                <path
                  d="M12 6c-5.33 0-9.67 4-9.67 4s4.33 4 9.67 4 9.67-4 9.67-4-4.33-4-9.67-4zm0 6.67c-1.47 0-2.67-1.2-2.67-2.67S10.53 7.33 12 7.33s2.67 1.2 2.67 2.67-1.2 2.67-2.67 2.67z"
                ></path>
                <circle cx="12" cy="10" r="2"></circle>
              </svg>
              <svg
                class="eye-icon"
                viewBox="0 0 24 24"
                *ngIf="showConfirmPassword"
              >
                <path
                  d="M12 6c-5.33 0-9.67 4-9.67 4s4.33 4 9.67 4 9.67-4 9.67-4-4.33-4-9.67-4zm0 6.67c-1.47 0-2.67-1.2-2.67-2.67S10.53 7.33 12 7.33s2.67 1.2 2.67 2.67-1.2 2.67-2.67 2.67z"
                ></path>
                <line
                  x1="4"
                  y1="4"
                  x2="20"
                  y2="20"
                  stroke="currentColor"
                  stroke-width="2"
                ></line>
              </svg>
            </button>
          </div>
          <div
            class="error-text"
            *ngIf="
              confirmPassword?.invalid &&
              (confirmPassword?.dirty || confirmPassword?.touched)
            "
          >
            <div *ngIf="confirmPassword?.errors?.['required']">
              Confirm password is required
            </div>
            <div *ngIf="confirmPassword?.errors?.['passwordMismatch']">
              Passwords do not match
            </div>
          </div>
        </div>

        <div class="alert alert-error" *ngIf="errorMessage && !tokenInvalid">
          <svg class="alert-icon" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
          <span>{{ errorMessage }}</span>
        </div>

        <button
          type="submit"
          class="signin-button"
          [disabled]="isSubmitting || resetPasswordForm.invalid || tokenInvalid"
          *ngIf="!tokenInvalid"
        >
          <span *ngIf="!isSubmitting">Reset Password</span>
          <div class="spinner" *ngIf="isSubmitting">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
        </button>

        <div class="signup-prompt">
          <span>Remember your password?</span>
          <a routerLink="/login" class="signup-link">Back to Login</a>
        </div>
      </form>
    </div>

    <div class="login-panel-right success-panel" *ngIf="resetSuccess">
      <div class="success-content">
        <div class="success-animation">
          <svg class="success-icon" viewBox="0 0 24 24">
            <path
              class="success-icon-circle"
              d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z"
            ></path>
            <path
              class="success-icon-check"
              d="M7.8,13.2l2.8,2.8l5.6-5.6"
            ></path>
          </svg>
        </div>

        <h2 class="success-title">Password Reset Complete</h2>
        <p class="success-message">{{ successMessage }}</p>

        <div class="redirect-container">
          <div class="redirect-progress">
            <div
              class="redirect-progress-bar"
              [style.width.%]="redirectProgress"
            ></div>
          </div>
          <p class="redirect-text">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
            Redirecting to login page...
          </p>
        </div>

        <div class="success-action">
          <a routerLink="/login" class="login-link">
            Login Now
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
